.disabled {
  opacity: 0.5;
  pointer-events: none;
}

gz-title + gz-form-field, gz-title + gz-labeled-content, gz-title + div {
  padding-top: 15px;
}

.form-field-info-text {
  padding-left: calc(var(--spacer) * 3.3);
  padding-top: calc(var(--spacer) * 0.5);
}

#rule-settings-extensions-field {
  margin-left: 250px;

  gz-chips-generator-input {
    --chip-list-width: 240px;
    --input-height: 105px;
  }
}

.checkbox-with-input {
  display: flex;
  align-items: center;

  .checkbox-width-250 {
    width: 250px;
  }

  .checkbox-width-290 {
    width: 290px;
  }

  .checkbox-width-410 {
    width: 410px;
  }
}

.multiple-dropdowns {
  display: flex;
  align-items: center;

  .first-dropdown-field {
    --form-field-label-width: 320px;
  }
  .second-dropdown-field {
    --form-field-label-width: 150px;
  }

  .first-dropdown-field + .second-dropdown-field {
    margin-left: 50px;
  }

  gz-dropdown {
    --form-field-input-width: 170px;
  }
}

#tasks-target-exclusions-field {
  margin-top: calc(var(--spacer)* -5); // remove extra space
}


#tasks-scheduler-date-and-time-section {
  margin-top: calc(var(--spacer) * 1.5);
  display: flex;
}

#tasks-scheduler-recurrence-section {
  display: block;
}

.form-field-label {
  width: var(--form-field-label-width);
  font-size: var(--body-size);
  padding-top: var(--spacer);
  color: var(--main-titles-inputs-600);
  display: inline-table;
}

gz-form-field {
  &#policy-panel-recurrence-run-per,
  &#policy-panel-recurrence-run-every,
  &#policy-panel-recurrence-weekdays-run-every {
    --margin-bottom-wrapper: var(--spacer);
  }
}

#tasks-scheduler-recurrence-step-type-field, #tasks-scheduler-stop-if-longer-step-type-field {
  gz-dropdown {
    --form-field-input-width: 138px;
  }
}

.radio {
  display: flex;
  align-items: center;
}

gz-radio {
  margin-right: calc(2 * var(--spacer));
  width: fit-content;
  &#policy-panel-recurrence-schedule-radio {
    width: calc(250px - calc(7 * var(--spacer)));
  }
  &#policy-panel-recurrence-weekdays-radio {
    min-width: 194px;
    margin-bottom: calc(var(--spacer) * 2);
  }
}


.container {
  display: flex;
  align-items: start;
  .objects {
    width: 250px;
  }
}

.subtitle {
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
}

gz-checkbox {
  width: auto;
}

gz-toggle {
  width: fit-content;
}
